@import '~less/global-variables';

.tribe-header {
  padding: 0;
  position: relative;
  min-height: 100vh;
  .tribe-header-back {
    padding-top: (@navbar-height + 50px);
    margin-left: -30px;
    [class^='icon-']:before,
    [class*=' icon-']:before {
      transition: all 0.2s ease-in-out;
      margin-right: 5px;
      margin-left: 5px;
    }
    &:hover {
      [class^='icon-']:before,
      [class*=' icon-']:before {
        margin-right: 10px;
        margin-left: 0;
      }
    }
  }
}
.tribe-header-info {
  width: 100%;
  min-height: 100vh;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  .tribe-pre {
    margin-bottom: 0;
  }
  .tribe-title {
    font-size: 46px;
    line-height: 55px;
  }
  .tribe-meta {
    margin-top: 10px;
  }
  .tribe-intro {
    margin-top: 40px;
  }
  .tribe-join.btn.btn-active {
    color: #fff;
  }
  .tribe-join {
    white-space: normal;
  }
  .tribe-actions-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-top: 18px;
    .btn {
      margin: 0;
      padding: 10px 16px;
      font-size: 16px;
      line-height: 1.5;
      border-radius: 6px;
      text-shadow: none;
    }
    .circle-membership-active {
      color: #fff;
      background: rgba(0, 0, 0, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.65);
      &:hover,
      &:focus {
        color: #fff;
        background: rgba(0, 0, 0, 0.35);
        border-color: #fff;
      }
    }
  }
}
// For non-authenticated members we show more text, so make header darker
.is-guest {
  .tribe-header-info {
    text-align: center;
    background: rgba(0, 0, 0, 0.6);
    @media (min-width: @screen-xs-min) {
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 40%,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    @media (min-width: @screen-md-min) {
      background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.8) 0%,
        rgba(0, 0, 0, 0.5) 40%,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    @media (min-width: @screen-xs-min) {
      text-align: left;
      .tribe-pre {
        font-size: 26px;
        line-height: 35px;
      }
      .tribe-title {
        font-size: 56px;
        line-height: 65px;
      }
    }
    .tribe-readmore {
      margin-left: 0;
      padding-left: 0;
    }
  }
}

.circle-member-discovery {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding-top: 28px;
  padding-bottom: 36px;
  @media (min-width: @screen-sm-min) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.circle-member-section {
  border-radius: 8px;
  padding: 20px;
  background: #f5f5f5;
  h3 {
    margin-top: 0;
  }
  ul {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 16px 0 0;
  }
  li {
    min-width: 0;
  }
  @media (min-width: @screen-md-min) {
    ul {
      grid-template-columns: 1fr 1fr;
    }
  }
}

.circle-member-empty {
  grid-column: 1 / -1;
  width: 100%;
  margin: 0;
  text-align: center;
}

.circle-member-row {
  margin: 0;
}
.circle-hero-map {
  margin-top: 20px;
  margin-bottom: 16px;
}
.tribe-header.has-location-map {
  min-height: 0;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: linear-gradient(transparent, @body-bg);
    pointer-events: none;
  }
  .tribe-header-info {
    min-height: 0;
    padding-bottom: 48px;
  }
  .container {
    width: 100%;
    max-width: 1600px;
    padding-inline: 24px;
  }
  .tribe-header-back {
    padding-top: 18px;
    padding-bottom: 12px;
    margin-left: -16px;
    font-size: 16px;
  }
  .tribe-intro {
    margin-top: 24px;
    font-size: 17px;
  }
  .tribe-attribution {
    bottom: 32px;
    padding: 8px 24px;
    z-index: 1;
  }
}
.hackers-circle-community {
  position: relative;
  display: grid;
  gap: 28px;
  width: calc(100% - 32px);
  max-width: 1552px;
  margin: -24px auto 32px;
  padding: 24px;
  border-radius: 14px;
  background: @body-bg;
  box-shadow: 0 -4px 18px rgba(0, 0, 0, 0.05);
  .hackers-circle-resources {
    min-width: 0;
  }
  h3 {
    margin-top: 0;
  }
  .circle-member-discovery {
    width: 100%;
    min-width: 0;
    padding: 0;
    grid-template-columns: minmax(0, 1fr);
    align-content: start;
  }
}
.hackers-circle-resource-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}
@media (min-width: @screen-md-min) {
  .circle-hero-map {
    margin-top: 0;
  }
  .hackers-circle-community.has-members {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr);
    gap: 36px;
  }
}

.tribe-attribution {
  display: block;
  position: absolute;
  bottom: 30px;
  right: 0;
  padding: 30px;
  a:not(.btn) {
    text-decoration: none;
  }
  // On bigger screens:
  // Make credits slightly opaque and add hover effects
  opacity: 0.5;
  a:hover {
    border-bottom: 1px solid #fff;
  }
  &:hover {
    transition: opacity 0.3s linear;
    opacity: 1;
  }
}

.tribe-share {
  float: left;
  margin: 0 15px 0 0;
}
